export default function isEmpty(value, allowBlank = false) {
    return value === null || value === undefined || (allowBlank ? false : value === '');
}
